import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditMultiChoice } from './edit/EditMultiChoice';
import { ViewMultiChoice } from './view/ViewMultiChoice';
export const MultiChoice = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const availableOptions = questionStore.availableOptions();
  const currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  const currentOptions = availableOptions.filter(option => currentAnswer.choices.includes(option.value));
  const hasOtherChoice = !!questionStore.otherChoiceId;
  const showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    const onChange = event => {
      const newChoiceId = event.target.value;
      const currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
      let newChoiceIds = [...toJS(currentAnswer.choices)];
      if (newChoiceIds.includes(newChoiceId)) {
        newChoiceIds = newChoiceIds.filter(choiceId => choiceId !== newChoiceId);
      } else {
        newChoiceIds.push(newChoiceId);
      }
      questionStore.setAnswer({
        text: hasOtherChoice && newChoiceIds.some(choiceId => choiceId === questionStore.otherChoiceId) ? currentAnswer.text : '',
        choices: newChoiceIds
      });
    };
    const otherChoiceSelected = hasOtherChoice && currentOptions.some(option => option.value === questionStore.otherChoiceId);
    const onOtherChoiceTextChange = event => {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditMultiChoice, {
      id: id,
      options: availableOptions,
      value: currentOptions,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange
    });
  }
  return /*#__PURE__*/React.createElement(ViewMultiChoice, {
    id: id,
    options: availableOptions,
    value: currentOptions,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});